// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__8LHN2.styles_ocean-50__qE-I6 {
  color: #e6f2ff;
}

.styles_color__8LHN2.styles_ocean-100__kCQ5H {
  color: #e6f2ff;
}

.styles_color__8LHN2.styles_ocean-200__H3C5E {
  color: #b3daff;
}

.styles_color__8LHN2.styles_ocean-300__0EjyX {
  color: #7abfff;
}

.styles_color__8LHN2.styles_ocean-400__wKJrU {
  color: #2392fb;
}

.styles_color__8LHN2.styles_ocean-500__PS8tB {
  color: #0074e0;
}

.styles_color__8LHN2.styles_ocean-600__cSiB0 {
  color: #043571;
}

.styles_color__8LHN2.styles_space-50__Du76L {
  color: #f0f0f0;
}

.styles_color__8LHN2.styles_space-100__5N0L6 {
  color: #e3e3e3;
}

.styles_color__8LHN2.styles_space-200__1Mb6H {
  color: #bfbfbf;
}

.styles_color__8LHN2.styles_space-300__odQ18 {
  color: gray;
}

.styles_color__8LHN2.styles_space-400__xJEpQ {
  color: #616161;
}

.styles_color__8LHN2.styles_space-500__Lc0lW {
  color: #283439;
}

.styles_color__8LHN2.styles_gray-50__hIEXb {
  color: #eff3f6;
}

.styles_color__8LHN2.styles_gray-100__RQTSW {
  color: #e6ecef;
}

.styles_color__8LHN2.styles_gray-200__wWx3p {
  color: #cfd8de;
}

.styles_color__8LHN2.styles_gray-300__WfvDA {
  color: #a8b9c2;
}

.styles_color__8LHN2.styles_gray-400__0YgfJ {
  color: #7e98a5;
}

.styles_color__8LHN2.styles_gray-500__MBMmU {
  color: #738f9c;
}

.styles_color__8LHN2.styles_green-50__lDcq7 {
  color: #e3fdf6;
}

.styles_color__8LHN2.styles_green-100__AyGHq {
  color: #c5f6ea;
}

.styles_color__8LHN2.styles_green-200__77MvG {
  color: #69ddc2;
}

.styles_color__8LHN2.styles_green-300__RlSzz {
  color: #45bfa3;
}

.styles_color__8LHN2.styles_green-400__pbHh8 {
  color: #1cab8a;
}

.styles_color__8LHN2.styles_green-500__aXlCv {
  color: #128268;
}

.styles_color__8LHN2.styles_red-50__K25Sm {
  color: #fff0f3;
}

.styles_color__8LHN2.styles_red-100__PPkBS {
  color: #f9d2db;
}

.styles_color__8LHN2.styles_red-200__Adhnh {
  color: #f8b4c4;
}

.styles_color__8LHN2.styles_red-300__BLMHQ {
  color: #e85e81;
}

.styles_color__8LHN2.styles_red-400__8TO2v {
  color: #e23661;
}

.styles_color__8LHN2.styles_red-500__BaZAu {
  color: #b82348;
}

.styles_color__8LHN2.styles_yellow-50__qDCJc {
  color: #fffae6;
}

.styles_color__8LHN2.styles_yellow-100__dSFry {
  color: #fff0b3;
}

.styles_color__8LHN2.styles_yellow-200__W9QCF {
  color: #ffe380;
}

.styles_color__8LHN2.styles_yellow-300__3GxaM {
  color: #ffcf57;
}

.styles_color__8LHN2.styles_yellow-400__58Z5e {
  color: #ffc60a;
}

.styles_color__8LHN2.styles_yellow-500__7iqke {
  color: #ffb700;
}

.styles_color__8LHN2.styles_orange-50__hYZyh {
  color: #fff2eb;
}

.styles_color__8LHN2.styles_orange-100__teR09 {
  color: #ffe4d6;
}

.styles_color__8LHN2.styles_orange-200__hLChx {
  color: #ffc69e;
}

.styles_color__8LHN2.styles_orange-300__dbmoL {
  color: #ffa047;
}

.styles_color__8LHN2.styles_orange-400__T5Bpr {
  color: #ff7b42;
}

.styles_color__8LHN2.styles_orange-500__ToIYN {
  color: #ee4920;
}

.styles_color__8LHN2.styles_turquoise-50__cs4p0 {
  color: transparent;
}

.styles_color__8LHN2.styles_turquoise-100__\\+Zgp- {
  color: #e6fcff;
}

.styles_color__8LHN2.styles_turquoise-200__4JREI {
  color: #b3f5ff;
}

.styles_color__8LHN2.styles_turquoise-300__7kOCe {
  color: #78e2f2;
}

.styles_color__8LHN2.styles_turquoise-400__ktJMK {
  color: #00c7e6;
}

.styles_color__8LHN2.styles_turquoise-500__rHQEI {
  color: transparent;
}

.styles_color__8LHN2.styles_turquoise-600__o3Iab {
  color: transparent;
}

.styles_color__8LHN2.styles_violet-50__gEUl\\+ {
  color: #eae6ff;
}

.styles_color__8LHN2.styles_violet-100__PHkq6 {
  color: #d9d1ff;
}

.styles_color__8LHN2.styles_violet-200__IqVuY {
  color: #bfb3ff;
}

.styles_color__8LHN2.styles_violet-300__eRNQH {
  color: #9d90ea;
}

.styles_color__8LHN2.styles_violet-400__Wgdcd {
  color: #8678d9;
}

.styles_color__8LHN2.styles_violet-500__s6w1f {
  color: #6f5ccc;
}

.styles_color__8LHN2.styles_snow-50__hlCDF {
  color: white;
}

.styles_color__8LHN2.styles_snow-100__OJVp3 {
  color: #f7f7f7;
}

.styles_color__8LHN2.styles_snow-200__EFuwM {
  color: #f0efef;
}

.styles_color__8LHN2.styles_snow-300__dELV5 {
  color: #e6e6e6;
}

.styles_color__8LHN2.styles_snow-400__Nmuk- {
  color: #e1e0e0;
}

.styles_color__8LHN2.styles_snow-500__TA1HD {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__mSoQ1.styles_ocean__sO5CR {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__mSoQ1.styles_ocean-light__zZVyJ {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__mSoQ1.styles_green__gCVIc {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__mSoQ1.styles_green-light__4op65 {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__mSoQ1.styles_red__hbS2M {
  background-color: #e23661;
  color: white;
}

.styles_background-color__mSoQ1.styles_red-light__kK4k7 {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__mSoQ1.styles_orange__W0qdC {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__mSoQ1.styles_orange-light__-LJuO {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__mSoQ1.styles_space__wxPFh {
  background-color: #616161;
  color: white;
}

.styles_background-color__mSoQ1.styles_space-light__popmN {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__mSoQ1.styles_gray-light__hNrrH {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__mSoQ1.styles_violet__6zf8m {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__mSoQ1.styles_violet-light__GxHbQ {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__mSoQ1.styles_yellow__erss3 {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__mSoQ1.styles_yellow-light__AcJOY {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
/* stylelint-disable no-descending-specificity */
/* stylelint-disable max-nesting-depth */
/* stylelint-disable declaration-property-value-disallowed-list */
.styles_root__joumf {
  display: inline-flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  vertical-align: middle;
}
.styles_root__joumf.styles_fullWidth__Hr-LH {
  width: 100%;
}
.styles_root__joumf.styles_error__04jfk .styles_inputWrapper__NR9Th {
  border-color: #b82348;
}
.styles_root__joumf:hover .styles_inputWrapper__NR9Th,
.styles_root__joumf:hover .styles_inputWrapper__NR9Th .styles_textInput__2IRhT {
  background-color: #f7f7f7;
}
.styles_root__joumf:hover .styles_lengthCounter__mhDg- {
  background-color: #f0efef;
}
.styles_root__joumf.styles_disabled__d6Guw .styles_inputWrapper__NR9Th {
  background-color: #f7f7f7;
  border-color: #eff3f6;
}
.styles_root__joumf.styles_disabled__d6Guw .styles_inputWrapper__NR9Th .styles_textInput__2IRhT {
  background-color: #f7f7f7;
  border-color: #eff3f6;
  color: #bfbfbf;
}
.styles_root__joumf.styles_disabled__d6Guw .styles_inputWrapper__NR9Th .styles_textInput__2IRhT::placeholder {
  color: #bfbfbf;
}
.styles_root__joumf.styles_disabled__d6Guw .styles_lengthCounter__mhDg- {
  background-color: #f0efef;
  color: #bfbfbf;
}

.styles_inputWrapper__NR9Th {
  background-color: white;
  border: 2px solid #e6ecef;
  border-radius: 5px;
  color: #283439;
  height: 40px;
  justify-self: center;
  line-height: normal;
  overflow: hidden;
  position: relative;
}
.styles_inputWrapper__NR9Th.styles_hasHeader__HHgua {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.styles_inputWrapper__NR9Th.styles_hasHeader__HHgua:focus, .styles_inputWrapper__NR9Th.styles_hasHeader__HHgua:focus-visible, .styles_inputWrapper__NR9Th.styles_hasHeader__HHgua:focus-within {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.styles_inputWrapper__NR9Th.styles_small__CX6hB {
  height: 32px;
}
.styles_inputWrapper__NR9Th:focus, .styles_inputWrapper__NR9Th.styles_focused__29gI3 {
  border-color: #2392fb;
}
.styles_inputWrapper__NR9Th.styles_textAreaWrapper__NDEER {
  height: 150px;
}
.styles_inputWrapper__NR9Th.styles_textAreaWrapper__NDEER.styles_small__CX6hB {
  height: 100px;
}
.styles_inputWrapper__NR9Th.styles_textAreaWrapper__NDEER:not(.styles_noMinWidth__CU\\+iO) {
  min-width: 420px;
}
.styles_inputWrapper__NR9Th .styles_textInput__2IRhT {
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  border: none;
  color: #283439;
  display: block;
  height: 100%;
  line-height: normal;
  outline: none;
  padding: 8px ;
  position: relative;
  width: 100%;
}
.styles_inputWrapper__NR9Th .styles_textInput__2IRhT.styles_textCenter__YoeKv {
  text-align: center;
}
.styles_inputWrapper__NR9Th .styles_textInput__2IRhT::placeholder {
  color: gray;
  -webkit-user-select: none;
          user-select: none;
}
.styles_inputWrapper__NR9Th .styles_textArea__t-TA2 {
  resize: none;
}
.styles_inputWrapper__NR9Th .styles_lengthCounter__mhDg- {
  font-weight: 400;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  background-color: #f7f7f7;
  border-radius: 1000px;
  bottom: 8px;
  color: #616161;
  line-height: normal;
  padding: 4px ;
  position: absolute;
  right: 8px;
  -webkit-user-select: none;
          user-select: none;
}

.styles_errorMessageWrapper__u7sNL {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  margin-top: 2px ;
  text-align: left;
}
.styles_errorMessageWrapper__u7sNL .styles_errorMessage__W1gNt {
  font-weight: 500;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: #e23661;
  display: inline-block;
  line-height: normal;
  margin-left: 2px ;
  margin-top: 2px ;
}

.styles_headerWrapper__xidpe {
  border: 2px solid #e6ecef;
  border-bottom: none;
  border-radius: 5px 5px 0 0;
}

.styles_clearHover__5-SLg:hover svg {
  color: gray;
}

.styles_snowBackground__r3zJN {
  background-color: #f7f7f7;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/text-field/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA,gDAAA;AACA,wCAAA;AACA,iEAAA;AAGA;EACI,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAwUJ;AAtUI;EACI,WAAA;AAwUR;AApUQ;EACI,qBAAA;AAsUZ;AAjUQ;;EAEI,yBAAA;AAmUZ;AAhUQ;EACI,yBAAA;AAkUZ;AA7TQ;EACI,yBAAA;EACA,qBAAA;AA+TZ;AA7TY;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;AA+ThB;AA7TgB;EACI,cAAA;AA+TpB;AA1TQ;EACI,yBAAA;EACA,cAAA;AA4TZ;;AAvTA;EACI,uBAAA;EACA,yBAAA;EACA,kBAxDQ;EAyDR,cAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA0TJ;AAxTI;EACI,yBAAA;EACA,0BAAA;AA0TR;AAxTQ;EAGI,2BAvEA;EAwEA,4BAxEA;AAgYZ;AApTI;EACI,YAAA;AAsTR;AAnTI;EAEI,qBAAA;AAoTR;AAjTI;EACI,aAAA;AAmTR;AAjTQ;EACI,aAAA;AAmTZ;AAhTQ;EACI,gBAAA;AAkTZ;AA9SI;EElDA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFoGjB,YAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAmTR;AAjTQ;EACI,kBAAA;AAmTZ;AAhTQ;EACI,WAAA;EACA,yBAAA;UAAA,iBAAA;AAkTZ;AA9SI;EACI,YAAA;AAgTR;AA7SI;EE7EA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EF+HjB,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;AAkTR;;AA9SA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAiTJ;AA/SI;EEnGA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFqJjB,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAoTR;;AAhTA;EACI,yBAAA;EACA,mBAAA;EACA,0BAAA;AAmTJ;;AAhTA;EACI,WAAA;AAmTJ;;AAhTA;EACI,yBAAA;AAmTJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n/* stylelint-disable no-descending-specificity */\n/* stylelint-disable max-nesting-depth */\n/* stylelint-disable declaration-property-value-disallowed-list */\n$md-radius: theme.get-border-radius(md);\n\n.root {\n    display: inline-flex;\n    flex-direction: column;\n    position: relative;\n    text-align: center;\n    vertical-align: middle;\n\n    &.fullWidth {\n        width: 100%;\n    }\n\n    &.error {\n        .inputWrapper {\n            border-color: theme.color(red-500);\n        }\n    }\n\n    &:hover {\n        .inputWrapper,\n        .inputWrapper .textInput {\n            background-color: theme.color(snow-100);\n        }\n\n        .lengthCounter {\n            background-color: theme.color(snow-200);\n        }\n    }\n\n    &.disabled {\n        .inputWrapper {\n            background-color: theme.color(snow-100);\n            border-color: theme.color(gray-50);\n\n            .textInput {\n                background-color: theme.color(snow-100);\n                border-color: theme.color(gray-50);\n                color: theme.color(space-200);\n\n                &::placeholder {\n                    color: theme.color(space-200);\n                }\n            }\n        }\n\n        .lengthCounter {\n            background-color: theme.color(snow-200);\n            color: theme.color(space-200);\n        }\n    }\n}\n\n.inputWrapper {\n    background-color: theme.color(snow-50);\n    border: 2px solid theme.color(gray-100);\n    border-radius: $md-radius;\n    color: theme.color(space-500);\n    height: 40px;\n    justify-self: center;\n    line-height: normal;\n    overflow: hidden;\n    position: relative;\n\n    &.hasHeader {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n\n        &:focus,\n        &:focus-visible,\n        &:focus-within, {\n            border-top-left-radius: $md-radius;\n            border-top-right-radius: $md-radius;\n        }\n    }\n\n    &.small {\n        height: 32px;\n    }\n\n    &:focus,\n    &.focused {\n        border-color: theme.color(ocean-400);\n    }\n\n    &.textAreaWrapper {\n        height: 150px;\n\n        &.small {\n            height: 100px;\n        }\n\n        &:not(.noMinWidth) {\n            min-width: 420px;\n        }\n    }\n\n    .textInput {\n        @include theme.typo(body3);\n\n        border: none;\n        color: theme.color(space-500);\n        display: block;\n        height: 100%;\n        line-height: normal;\n        outline: none;\n        padding: theme.spacing(1);\n        position: relative;\n        width: 100%;\n\n        &.textCenter {\n            text-align: center;\n        }\n\n        &::placeholder {\n            color: theme.color(space-300);\n            user-select: none;\n        }\n    }\n\n    .textArea {\n        resize: none;\n    }\n\n    .lengthCounter {\n        @include theme.typo(info3);\n\n        background-color: theme.color(snow-100);\n        border-radius: theme.get-border-radius(pill);\n        bottom: 8px;\n        color: theme.color(space-400);\n        line-height: normal;\n        padding: theme.spacing(0.5);\n        position: absolute;\n        right: 8px;\n        user-select: none;\n    }\n}\n\n.errorMessageWrapper {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: row;\n    margin-top: theme.spacing(0.25);\n    text-align: left;\n\n    .errorMessage {\n        @include theme.typo(info2);\n\n        color: theme.color(red-400);\n        display: inline-block;\n        line-height: normal;\n        margin-left: theme.spacing(0.25);\n        margin-top: theme.spacing(0.25);\n    }\n}\n\n.headerWrapper {\n    border: 2px solid theme.color(gray-100);\n    border-bottom: none;\n    border-radius: $md-radius $md-radius 0 0;\n}\n\n.clearHover:hover svg {\n    color: theme.color(space-300);\n}\n\n.snowBackground {\n    background-color: theme.color(snow-100);\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__8LHN2`,
	"ocean-50": `styles_ocean-50__qE-I6`,
	"ocean-100": `styles_ocean-100__kCQ5H`,
	"ocean-200": `styles_ocean-200__H3C5E`,
	"ocean-300": `styles_ocean-300__0EjyX`,
	"ocean-400": `styles_ocean-400__wKJrU`,
	"ocean-500": `styles_ocean-500__PS8tB`,
	"ocean-600": `styles_ocean-600__cSiB0`,
	"space-50": `styles_space-50__Du76L`,
	"space-100": `styles_space-100__5N0L6`,
	"space-200": `styles_space-200__1Mb6H`,
	"space-300": `styles_space-300__odQ18`,
	"space-400": `styles_space-400__xJEpQ`,
	"space-500": `styles_space-500__Lc0lW`,
	"gray-50": `styles_gray-50__hIEXb`,
	"gray-100": `styles_gray-100__RQTSW`,
	"gray-200": `styles_gray-200__wWx3p`,
	"gray-300": `styles_gray-300__WfvDA`,
	"gray-400": `styles_gray-400__0YgfJ`,
	"gray-500": `styles_gray-500__MBMmU`,
	"green-50": `styles_green-50__lDcq7`,
	"green-100": `styles_green-100__AyGHq`,
	"green-200": `styles_green-200__77MvG`,
	"green-300": `styles_green-300__RlSzz`,
	"green-400": `styles_green-400__pbHh8`,
	"green-500": `styles_green-500__aXlCv`,
	"red-50": `styles_red-50__K25Sm`,
	"red-100": `styles_red-100__PPkBS`,
	"red-200": `styles_red-200__Adhnh`,
	"red-300": `styles_red-300__BLMHQ`,
	"red-400": `styles_red-400__8TO2v`,
	"red-500": `styles_red-500__BaZAu`,
	"yellow-50": `styles_yellow-50__qDCJc`,
	"yellow-100": `styles_yellow-100__dSFry`,
	"yellow-200": `styles_yellow-200__W9QCF`,
	"yellow-300": `styles_yellow-300__3GxaM`,
	"yellow-400": `styles_yellow-400__58Z5e`,
	"yellow-500": `styles_yellow-500__7iqke`,
	"orange-50": `styles_orange-50__hYZyh`,
	"orange-100": `styles_orange-100__teR09`,
	"orange-200": `styles_orange-200__hLChx`,
	"orange-300": `styles_orange-300__dbmoL`,
	"orange-400": `styles_orange-400__T5Bpr`,
	"orange-500": `styles_orange-500__ToIYN`,
	"turquoise-50": `styles_turquoise-50__cs4p0`,
	"turquoise-100": `styles_turquoise-100__+Zgp-`,
	"turquoise-200": `styles_turquoise-200__4JREI`,
	"turquoise-300": `styles_turquoise-300__7kOCe`,
	"turquoise-400": `styles_turquoise-400__ktJMK`,
	"turquoise-500": `styles_turquoise-500__rHQEI`,
	"turquoise-600": `styles_turquoise-600__o3Iab`,
	"violet-50": `styles_violet-50__gEUl+`,
	"violet-100": `styles_violet-100__PHkq6`,
	"violet-200": `styles_violet-200__IqVuY`,
	"violet-300": `styles_violet-300__eRNQH`,
	"violet-400": `styles_violet-400__Wgdcd`,
	"violet-500": `styles_violet-500__s6w1f`,
	"snow-50": `styles_snow-50__hlCDF`,
	"snow-100": `styles_snow-100__OJVp3`,
	"snow-200": `styles_snow-200__EFuwM`,
	"snow-300": `styles_snow-300__dELV5`,
	"snow-400": `styles_snow-400__Nmuk-`,
	"snow-500": `styles_snow-500__TA1HD`,
	"background-color": `styles_background-color__mSoQ1`,
	"ocean": `styles_ocean__sO5CR`,
	"ocean-light": `styles_ocean-light__zZVyJ`,
	"green": `styles_green__gCVIc`,
	"green-light": `styles_green-light__4op65`,
	"red": `styles_red__hbS2M`,
	"red-light": `styles_red-light__kK4k7`,
	"orange": `styles_orange__W0qdC`,
	"orange-light": `styles_orange-light__-LJuO`,
	"space": `styles_space__wxPFh`,
	"space-light": `styles_space-light__popmN`,
	"gray-light": `styles_gray-light__hNrrH`,
	"violet": `styles_violet__6zf8m`,
	"violet-light": `styles_violet-light__GxHbQ`,
	"yellow": `styles_yellow__erss3`,
	"yellow-light": `styles_yellow-light__AcJOY`,
	"root": `styles_root__joumf`,
	"fullWidth": `styles_fullWidth__Hr-LH`,
	"error": `styles_error__04jfk`,
	"inputWrapper": `styles_inputWrapper__NR9Th`,
	"textInput": `styles_textInput__2IRhT`,
	"lengthCounter": `styles_lengthCounter__mhDg-`,
	"disabled": `styles_disabled__d6Guw`,
	"hasHeader": `styles_hasHeader__HHgua`,
	"small": `styles_small__CX6hB`,
	"focused": `styles_focused__29gI3`,
	"textAreaWrapper": `styles_textAreaWrapper__NDEER`,
	"noMinWidth": `styles_noMinWidth__CU+iO`,
	"textCenter": `styles_textCenter__YoeKv`,
	"textArea": `styles_textArea__t-TA2`,
	"errorMessageWrapper": `styles_errorMessageWrapper__u7sNL`,
	"errorMessage": `styles_errorMessage__W1gNt`,
	"headerWrapper": `styles_headerWrapper__xidpe`,
	"clearHover": `styles_clearHover__5-SLg`,
	"snowBackground": `styles_snowBackground__r3zJN`
};
export default ___CSS_LOADER_EXPORT___;
